import React, {useEffect} from "react";
import t, {changeLanguage} from "../../components/I18N/TranslateHelpers";
import {
  GetCurrentLocale,
} from "../../components/Utils";
import {URL_FOR_RESOURCES} from "../../app/AppConfig";
import {useDispatch, useSelector} from "react-redux";
import {SpinnerOnTop} from "../../components/SpinnerOnTop";
import {RootState} from "../../app/RootReducer";
import CartSummaryTotal from "./CartSummaryTotal";
import {getVariantOfProduct} from "../../components/UtilsForCart";
import ProductPrice from "../Products/ProductPrice/ProductPrice";
import {getProductIdFromItem} from "../../components/Catalogue/userCatalogUtils";
import {renderSelect, renderTextArea} from "../../components/Forms/FormsComponent";
import {getUserAccount, getUserAddress} from "../User/UsersSlice";

interface ComponentProps {
  userAccount: any
  guestData: any
  activeStep: number
  selectedCountry: any,
  setRemarqueText: React.Dispatch<React.SetStateAction<string>> | undefined,
  selectedAddressId: number | null,
  setSelectedAddressId: React.Dispatch<React.SetStateAction<number | null>>
}

const Checkout: React.FC<ComponentProps> = ({userAccount,
                                              guestData,
                                              activeStep,
                                              selectedCountry,
                                              setRemarqueText,
                                              selectedAddressId,
                                              setSelectedAddressId
                                            }:ComponentProps) => {
  const locale = GetCurrentLocale();
  changeLanguage(locale)
  const dispatch = useDispatch()
  const isAuthenticated = useSelector((state: RootState) => state.userRdc.isAuthenticated);
  const isRequesting = useSelector((state:RootState) => state.userRdc.isRequesting)
  const itemsInCart = useSelector((state: RootState) => state.cartRdc.cart )
  const userAddresses = useSelector((state: RootState) => state.userRdc.userAddresses ?? []);
  const addressOptions = userAddresses.map((addr) => ({
    label: `${addr.street}, ${addr.postcode} ${addr.city}`,
    value: addr.id,
  }));

  const defaultAddress = userAccount?.defaultAddress;
  const defaultAddressId = defaultAddress ? parseInt(defaultAddress.split('/').pop()!, 10) : null;
  useEffect(() => {
    if (selectedAddressId === null && defaultAddressId && userAddresses.length > 0) {
      setSelectedAddressId(defaultAddressId);
    }
  }, [defaultAddressId, userAddresses, selectedAddressId]);

  useEffect(() => {
    if(isAuthenticated){
      dispatch(getUserAccount(false,false));
      dispatch(getUserAddress());
    }
  }, []);

  return (
        <div className="page slide-page-summary py-0 px-0">
          <article className="row nomargin">
            <div className="col-md-6">
              <div className="content-body card mb-5">
                <h5 className="card-title">{t('order_summary')}</h5>
                <p className="text-muted">{t('products')} </p>
                {
                  itemsInCart && itemsInCart.items && itemsInCart.items.length > 0 && itemsInCart.items.map((productItem: any, index) => {
                    return (
                      <React.Fragment key={index}>
                        <div className="itemside align-items-center mb-0">
                          <div className="aside">
                            <b className="badge bg-secondary rounded-pill">{productItem.quantity}</b>
                            <img src={URL_FOR_RESOURCES + "/media/image/" + productItem.product.imageUrl}
                                 className="img-sm rounded border" alt={productItem.productName}/>
                          </div>
                          <div className="info">
                            <div className="variation">
                          <span>
                            <strong className="h6 price">{productItem.productName}</strong>
                          </span>
                              {getVariantOfProduct(productItem)}
                            </div>
                          </div>
                          <div className="aside">
                            <ProductPrice
                              productItem={{
                                ...productItem,
                                id: getProductIdFromItem(productItem, false),
                              }}
                              mode="cart"
                            />
                          </div>
                        </div>
                        {
                          index !== itemsInCart.items.length - 1 ?
                            <hr/>
                            : null
                        }
                      </React.Fragment>
                    )
                  })
                }
              </div>
              <div className="card">
                <div className="card-body">
                  {
                    renderTextArea(t('add_remark'), "remark", false, setRemarqueText)
                  }
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-md-12 card personnal-info mt-0">
                  <div className="content-body">
                    <h5 className="card-title">{t('personal_info')}</h5>
                    <div className="row">
                      {
                        !isRequesting && userAccount ?
                          <>
                            <div className="col-6 mb-3">
                          <span
                            className="h6">{userAccount && userAccount.lastName || guestData.lastName} {userAccount && userAccount.firstName || guestData.firstName}</span>
                              <br/>
                            </div>
                            <div className="col-6">
                              <span>{userAccount && userAccount.email || guestData.email}</span>
                            </div>
                          </>
                          : <SpinnerOnTop/>
                      }
                      <h5 className="card-title">{t('select_billing_address')}</h5>
                      <div className="col-md-12 mb-3">
                        {
                          renderSelect(
                            locale,
                            t('select_billing_address'),
                            "selectedAddress",
                            (selected: any) => setSelectedAddressId(selected?.value || null),
                            true,
                            addressOptions,
                            addressOptions.find(opt => opt.value === selectedAddressId) || null
                          )
                        }
                      </div>
                      <div className="col-md-12">
                        <a href={"/" + locale + t('url_profile') + "?tab=tab_addresses"} target="_blank">
                          <div className="alert alert-info-fiche alert-dashed d-flex align-items-center width100">
                            <i className="fa-solid fa-circle-info mr-2"></i> {t('edit_addresses_profile')}
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <CartSummaryTotal itemsInCart={itemsInCart} activeStep={activeStep}/>
            </div>
          </article>
        </div>
  )
}

export default Checkout;
